import { ActorListEnum } from '@e-socna/data-layer';

export type ActorListKey = 'internalActors' | 'externalActors';

// The list of actors a tab edits: the internal actors (the group doing the work) or the external
// ones (facing them).
export const actorListOf = (isInternal: boolean): ActorListEnum =>
  isInternal ? ActorListEnum.Internal : ActorListEnum.External;

export const actorListKeyOfList = (list: ActorListEnum): ActorListKey =>
  list === ActorListEnum.Internal ? 'internalActors' : 'externalActors';

export const actorListKeyOf = (isInternal: boolean): ActorListKey =>
  actorListKeyOfList(actorListOf(isInternal));
